import {
  MisconfigCellRenderer,
  NameCellRenderer,
  SecurityScoreCellRenderer,
  VendorTypeCellRenderer,
} from "../cell_renderers";
import { TABLE_INFO } from "../shared/table_config";

const { HEADER_LABEL: tableHeader, PROPS: tableProps } =
  TABLE_INFO.CLOUD_LOWEST_SCORE;

export const cloudLowestScoresColumnDefs = [
  {
    headerName: tableHeader.NAME,
    field: tableProps.NAME,
    flex: 4,
    filter: false,
    cellRenderer: NameCellRenderer,
    lockPosition: true,
    lockPinned: true,
    cellRendererParams: {
      fieldMapping: {
        ...tableProps,
      },
    },
  },
  {
    headerName: "Vendor-Type",
    field: "vendor",
    flex: 3,
    cellRenderer: VendorTypeCellRenderer,
    filter: false,
    sortable: true,
  },
  {
    headerName: tableHeader.SCORE,
    field: tableProps.SCORE,
    flex: 2,
    cellRenderer: SecurityScoreCellRenderer,
    filter: false,
    sortable: true,
    // sort: "asc",
  },
  {
    headerName: tableHeader.MISCONFIGURATION,
    field: tableProps.MISCONFIGURATION,
    flex: 2,
    cellRenderer: MisconfigCellRenderer,
    filter: false,
    sortable: true,
  },
];
